export class GeoCode {
    coordinate: Coordinate;
    address: string;
    zoom: number;

    constructor() {}

}

export class Coordinate {
    lat: number;
    lng: number

    constructor() { }
}